import React from 'react';
import { ArrowRightIcon, ClipboardCheckIcon, ShieldIcon, WrenchIcon } from 'lucide-react';
import { assets, safetyPractices } from '../data/content';
import { SectionLabel } from './SectionLabel';
const icons = [ClipboardCheckIcon, WrenchIcon, ShieldIcon];
export function Safety() {
  return <section id="safety" aria-labelledby="safety-heading" className="ink-surface w-full bg-ink py-20 lg:py-28" data-id="element-201" data-mp="2b03vtdfv4ph9">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-202" data-mp="2oyv5mnnozozl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-203" data-mp="2kz2wa8qh5et6">
          <div className="lg:col-span-5" data-id="element-204" data-mp="2kx035fu0z5k8">
            <SectionLabel number="03" tone="light" data-id="element-205" data-mp="2yp69693grw5y">
              Safety
            </SectionLabel>
            <h2 id="safety-heading" className="mt-5 font-display text-[34px] font-semibold uppercase leading-[1.02] text-white sm:text-[44px] lg:text-[50px]" data-id="element-206" data-mp="2ts62bvysipds">
              Safety is part of the work. Every day.
            </h2>
            <img src={assets.safety} alt="Crew and lifting equipment installing a utility-site gate" width={1759} height={894} loading="lazy" decoding="async" className="mt-8 aspect-[15/8] w-full border border-steel/60 object-cover" data-id="element-207" data-mp="2rwx00jllyajk" />
          </div>

          <div className="lg:col-span-7" data-id="element-208" data-mp="35xq0dkylbzul">
            <p className="max-w-2xl text-base leading-relaxed text-steel-300 sm:text-lg" data-id="element-209" data-mp="3avrjg5w0nz62">
              Our safety practices include daily toolbox talks, weekly equipment inspections and
              flame-resistant (FR) uniforms. These are part of our commitment to a safe work
              environment for employees and customers.
            </p>

            <ul className="mt-10 grid grid-cols-1 gap-px bg-ink-700 sm:grid-cols-3" data-id="element-210" data-mp="3om4nhx5setq4">
              {safetyPractices.map((practice, index) => {
              const Icon = icons[index];
              return <li key={practice.title} className="flex flex-col bg-ink p-6" data-id="element-211" data-mp="2dlhh3wpxv77" data-mpi={index}>
                    <Icon aria-hidden="true" className="h-6 w-6 text-safety" data-id="element-212" data-mp="1yj44ctif7ppb" />
                    <h3 className="mt-4 min-h-[3.4rem] font-display text-[21px] font-semibold uppercase leading-tight text-white" data-id="element-213" data-mp="1tl2la8kzvqdu">
                      {practice.title}
                    </h3>
                    <p className="mt-1 text-[15px] leading-relaxed text-steel-300" data-id="element-214" data-mp="23gw58d11mm5n">
                      {practice.body}
                    </p>
                  </li>;
            })}
            </ul>

            <a href="#contact" className="mt-10 inline-flex min-h-[48px] items-center gap-2 font-display text-[17px] uppercase tracking-[0.08em] text-safety transition-colors duration-150 ease-industrial hover:text-white" data-id="element-215" data-mp="2d779y1sjwzdl">
              Discuss your site requirements
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-216" data-mp="wtqw8jqe2ka6" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}